import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { MatDialog} from '@angular/material/dialog';
import { IcustomerTypeWiseDiscountProductPriceEditDialogBoxComponent } from '../icustomer-type-wise-discount-product-price-edit-dialog-box/icustomer-type-wise-discount-product-price-edit-dialog-box.component';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-icustomer-type-wise-discount-product-price',
  templateUrl: './icustomer-type-wise-discount-product-price.component.html',
  styleUrls: ['./icustomer-type-wise-discount-product-price.component.scss']
})
export class IcustomerTypeWiseDiscountProductPriceComponent implements OnInit {
  discount_products: any;
  icustomer_types: any;
  discount_price: any;

  constructor(private http : HttpService, public dialog: MatDialog, public global: GlobalService) {
    this.global.set_master_page_title = 'ICustomer Typewise Discount Price';
    this.getProducts();
    this.getIcustomerTypeWiseDiscountProduct();
    this.getIcustomerTypeWiseDiscountPriceDict();
   }


  getProducts() {
    console.log('products')
    this.http.getIcustomerWiseDiscountPriceDict().subscribe((data: []) => {
      console.log(data);
      this.discount_products = data;
    }, (error) => {
      console.log(error);
    });
  }

  
  getIcustomerTypeWiseDiscountProduct() {
    console.log('icustomer type wise')
    this.http.getCustomerType().subscribe((data: []) => {
      console.log(data);
      this.icustomer_types = data;
    }, (error) => {
      console.log(error);
    });
  }


  getIcustomerTypeWiseDiscountPriceDict() {
    console.log('icustomer type price')
    this.http.getIcustomerTypeWiseDiscountPrice().subscribe((data: []) => {
      console.log(data);
      this.discount_price = data;
    }, (error) => {
      console.log(error);
    });
  }

  discountPrice(icustomer_type_id, product_id) {
    if (this.discount_price.hasOwnProperty(icustomer_type_id)) {
      if (this.discount_price[icustomer_type_id].hasOwnProperty(product_id)) {
        return this.discount_price[icustomer_type_id][product_id];
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }


  openDialog(customer_type_id: number, customer_type_name: string, product_id: number, product_name: string, discount_price: number): void {
    console.log('dialog open');
    console.log(customer_type_id)
    const dialogRef = this.dialog.open(IcustomerTypeWiseDiscountProductPriceEditDialogBoxComponent, {
      height: '400px',
      width: '600px',
      data: {
        'customer_type_id': customer_type_id,
        'customer_type_name': customer_type_name,
        'product_id': product_id,
        'product_name': product_name,
        'discount_price': discount_price
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      if ((res !== null) && (res !== undefined)) {
        this.updateDiscountPrice(res);
      }
    });
  }



  updateDiscountPrice(result) {
    console.log('update commission');
    if (this.discount_price.hasOwnProperty(result['customer_type_id']) === false) {
      console.log('with in if');
      this.discount_price[result['customer_type_id']] = {};
      this.discount_price[result['customer_type_id']][result['product_id']] = result['discount_price'];
    } else {
      this.discount_price[result['customer_type_id']][result['product_id']] = result['discount_price'];
    }
  }

  
  

  ngOnInit() {
  }

}
